import Marquee from "react-fast-marquee";

const ITEMS = ["Estielle", "The bar brought to you", "Craft cocktails", "Private events", "Weddings", "Brand launches"];

function Diamond() {
  return <span className="mx-10 inline-block h-2 w-2 rotate-45 bg-[#D98B48]/50" aria-hidden="true" />;
}

export default function Ribbon() {
  return (
    <div className="border-y border-white/10 bg-[#0C0C0C] py-6" data-testid="marquee-ribbon">
      <Marquee speed={45} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center whitespace-nowrap font-display text-2xl md:text-3xl italic text-white/25">
            {item}
            <Diamond />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
